import { Navigate } from 'react-router-dom'

export default function CustomerSuccess() {
    return <Navigate to="/" replace />
}
